"use client";

import { useEffect } from "react";

/**
 * Tracks the bottom edge of the sticky <header> in viewport pixels and exposes
 * it as `--header-bottom` on the document root. The snackbar mounts/unmounts
 * above the header, and the header itself becomes sticky once scrolled — both
 * change where the header bottom sits in the viewport. Components that need to
 * size or position something flush below the header (e.g. the search panel)
 * read this variable instead of hardcoding the header height.
 */
export const HeaderBottomVar = () => {
	useEffect(() => {
		const header = document.querySelector("header");
		if (!header) return;

		let frame = 0;
		const update = () => {
			const bottom = header.getBoundingClientRect().bottom;
			document.documentElement.style.setProperty("--header-bottom", `${Math.max(0, bottom)}px`);
		};
		const schedule = () => {
			if (frame) return;
			frame = requestAnimationFrame(() => {
				frame = 0;
				update();
			});
		};

		update();
		const ro = new ResizeObserver(schedule);
		ro.observe(document.body);
		ro.observe(header);
		window.addEventListener("scroll", schedule, { passive: true });
		window.addEventListener("resize", schedule);

		return () => {
			if (frame) cancelAnimationFrame(frame);
			ro.disconnect();
			window.removeEventListener("scroll", schedule);
			window.removeEventListener("resize", schedule);
		};
	}, []);

	return null;
};
